import { Component, Input } from "@angular/core";

@Component({
    selector: "app-spinner",
    templateUrl: "./spinner.component.html",
    styles: [
        `
    `,
    ],
    standalone: false
})
export class SpinnerComponent {
  @Input() isLoading: boolean;
  @Input() diameter: string = "40";
  @Input() spinnerColor: string = "accent";
  @Input() loadingText: string = "Loading..."
  @Input() showText: boolean = true;
}
